module.exports = __webpack_public_path__ + "img/accent-grave.c06aa722.svg";